import React from 'react'

export default function Checkbox({ corrected, setCorrected }) {

	return (
		<input
			name="corrected"
			type="checkbox"
			checked={corrected}
			onChange={(e) => setCorrected(e.target.checked)}
		/>
	)
}
